import { InterestRate } from '../api/httpHandlers'

interface Props {
  options: InterestRate[]
}

function getDescriptionFromBindingPeriod(bindingPeriod: number) {
  return bindingPeriod < 12 ? `${bindingPeriod} månader` : `${bindingPeriod / 12} år`
}

export default function RatesOptions({ options }: Readonly<Props>) {
  return (
    <>
      {options.length > 0
        ? options.map((value, index) => {
            const { customerRate, bindingPeriod } = value
            const description = getDescriptionFromBindingPeriod(bindingPeriod)
            const optionValue = +customerRate
            const optionId = `option-${optionValue}-${description}`
            return (
              <option key={optionId} value={index.toString()} data-option-value={optionValue}>
                {description + ' - ' + customerRate.replace('.', ',') + '\u00A0%'}
              </option>
            )
          })
        : null}
    </>
  )
}
